var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMembership)?_c('div',[_c('AppWarning',{attrs:{"text":_vm.getText(),"type":_vm.getType(),"showButton":_vm.getShowButton(),"buttonAction":_vm.renewAppleMembership,"buttonText":"Marcar como renovado"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }